import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'team-set-search-dialog',
    templateUrl: './team-set-search-dialog.component.html',
    providers: [DataService]
})
export class TeamSetSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        this.objectType = 'DBQuery';
        this.model.title = 'Select Team Set';

        this.model.criteria.Procedure_Name = 'epx_getteamsetlist';
        this.model.criteria.bookentityid = 'CURRENTBOOK';
        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
